import authType from "./thirdPartyWebhookTypes";

const initialState = {
  isLoading: false,
  creating: false,
  deleting: false,
  my3PWebhooks: {},
};

export default function thirdPartyWebhookReducer(state = initialState, action) {
  switch (action.type) {
    case authType.LOADING:
      return {
        ...state,
        isLoading: action.payLoad,
      };

    case authType.CREATING:
      return {
        ...state,
        creating: action.payLoad,
      };

    case authType.DELETING:
      return {
        ...state,
        deleting: action.payLoad,
      };

    case authType.MY_THIRD_PARTY_WEBHOOKS:
      return {
        ...state,
        my3PWebhooks: action.payLoad?.data,
      };

    default:
      return state;
  }
}
